import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';

import HeaderShowcase from './HeaderShowcase';
import { FILTERKEYS } from './constants';

const HeadersList = ({ content }) => {
  const dataGroup = groupBy(content, 'type');
  const dataKeys = Object.keys(dataGroup);

  return (
    <Fragment>
      {dataKeys.map(group => (
        <section key={`${group}-header-group`}>
          <h2 className="h2 page-subtitle">{FILTERKEYS[group]}</h2>
          <ul className="showcase-list">
            {
              dataGroup[group].map(group => (
                group.previews.map((headers, i) => (
                  <li key={`header-${group.type}-showcase-${i}`}>
                    <HeaderShowcase {...headers} />
                  </li>
                ))
              ))
            }
          </ul>
        </section>
      ))}
    </Fragment>
  );
};

HeadersList.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object)
};

HeadersList.displayName = 'HeadersList';

export default HeadersList;


// WEBPACK FOOTER //
// ./src/containers/components/Header/HeadersList.js